import { render, staticRenderFns } from "./marketWayList.vue?vue&type=template&id=4838ed0c&scoped=true"
import script from "./marketWayList.vue?vue&type=script&lang=js"
export * from "./marketWayList.vue?vue&type=script&lang=js"
import style0 from "./marketWayList.vue?vue&type=style&index=0&id=4838ed0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4838ed0c",
  null
  
)

export default component.exports